import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const COOKIE_CONSENT_KEY = "cookie_consent";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      setIsVisible(!consent);
    };

    checkConsent();

    // Small delay for better UX on initial load
    const timer = setTimeout(() => {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (!consent) setIsVisible(true);
    }, 1500);

    window.addEventListener("cookie-consent-reset", checkConsent);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("cookie-consent-reset", checkConsent);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "rejected");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="container mx-auto max-w-4xl">
            <div className="bg-card border border-border rounded-2xl shadow-2xl p-5 md:p-6">
              <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
                {/* Icon and Text */}
                <div className="flex items-start gap-4 flex-1">
                  <div className="p-2 bg-gold/10 rounded-xl flex-shrink-0">
                    <Cookie className="w-6 h-6 text-gold" />
                  </div>
                  <div>
                    <p className="text-charcoal font-medium mb-1">
                      Táto stránka používa cookies
                    </p>
                    <p className="text-sm text-muted-foreground">
                      Používame cookies na zlepšenie používateľského zážitku.{" "}
                      <a 
                        href="/gdpr" 
                        className="text-[#7a5a15] hover:text-charcoal underline font-medium"
                      >
                        GDPR
                      </a>
                      {" | "}
                      <a 
                        href="/vop" 
                        className="text-[#7a5a15] hover:text-charcoal underline font-medium"
                      >
                        VOP
                      </a>
                    </p>
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex items-center gap-3 flex-shrink-0">
                  <button
                    onClick={handleReject}
                    className="px-5 py-2.5 text-sm font-medium text-muted-foreground hover:text-charcoal border border-border rounded-xl hover:bg-secondary transition-all duration-300"
                  >
                    Odmietnuť
                  </button>
                  <button
                    onClick={handleAccept}
                    className="px-5 py-2.5 text-sm font-medium bg-charcoal text-primary-foreground rounded-xl hover:bg-charcoal/90 transition-all duration-300"
                  >
                    Prijať
                  </button>
                </div>

                {/* Close button */}
                <button
                  onClick={handleReject}
                  className="absolute top-3 right-3 md:hidden p-1.5 text-muted-foreground hover:text-charcoal rounded-lg hover:bg-secondary transition-colors"
                  aria-label="Zavrieť"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default CookieBanner;
